import { useState } from 'react';
import Iconify from 'src/components/Iconify';
import v2_actionCriarContato from 'src/actions/v2/contatos/v2_actionCriarContato';
import { validarNumeroWhatsapp } from 'src/utils/functions';
import { useSnackbar } from 'notistack';
import VerContatoForm from './VerContatoForm';
import ModalAlerta from 'src/components/modal/ModalAlerta';

import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "src/@/components/ui/dialog";

// ----------------------------------------------------------------------

export default function ModalVerContato({
    user,
    cliente,
    open,
    contatoData,
    listaClientesCanais,
    loading,
    callBackRefreshList,
    onClose
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [loadingNovoContato, setLoadingNovoContato] = useState(false);
    const [openModalAlerta, setOpenModalAlerta] = useState(false);
    const [mensagemModalAlerta, setMensagemModalAlerta] = useState('');


    async function handleCriarContato(data) {
        const { contato, endereco, camposPersonalizados } = data;
        setLoadingNovoContato(true);
        try {
            let data = {
                scope: {
                    nome: contato.nome,
                    telefone: validarNumeroWhatsapp(contato.whatsapp),
                    info: {
                        email: contato.email,
                        cpf: contato.cpf,
                        dataNascimento: contato.dataNascimento,
                        endereco
                    },
                },
                custom_fiels: camposPersonalizados,
                cliente_id: cliente._id,
                usuario_id: user.id
            }
            const response = await v2_actionCriarContato(data);
            if (response.status === 200) {
                setLoadingNovoContato(false);
                onClose();
                enqueueSnackbar('Contato criado com sucesso', { variant: 'success' });
            }
        } catch (error) {
            console.log(error)
            setLoadingNovoContato(false);
            enqueueSnackbar('Erro ao criar contato', { variant: 'error' });
        }
    }

    return (
        <>
            <ModalAlerta
                open={openModalAlerta}
                mensagem={mensagemModalAlerta}
                onClose={() => {
                    setOpenModalAlerta(false);
                    setMensagemModalAlerta('');
                }}
            />

            <Dialog open={open} onOpenChange={(value) => { if (!value) onClose(); }}>
                <DialogContent className="sm:max-w-[520px] max-h-[90vh] flex flex-col gap-0 p-0 dark:bg-[#222529] dark:border-[#383838]">
                    <DialogHeader className="px-6 py-4 border-b border-gray-100 dark:border-[#383838] shrink-0">
                        <div className="flex items-center gap-3">
                            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#7C3AED]/10">
                                <Iconify icon="fluent:person-20-filled" width={20} className="text-[#7C3AED]" />
                            </div>
                            <div>
                                <DialogTitle className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]">
                                    Ver contato
                                </DialogTitle>
                                <p className="text-[10px] text-gray-500 dark:text-[#ABABAD] font-medium">
                                    Visualize e edite as informações do contato
                                </p>
                            </div>
                        </div>
                    </DialogHeader>

                    <div className="flex-1 overflow-y-auto px-6 py-4">
                        {contatoData && (
                            <VerContatoForm
                                callBackRefreshList={callBackRefreshList}
                                contatoData={contatoData}
                                cliente={cliente}
                                showSaveButton={true}
                                hideSelectEmpresa={true}
                                showSignupButton={false}
                                loadingNovoContato={loadingNovoContato}
                                callbackAddContact={data => handleCriarContato(data)}
                            />
                        )}
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}
